// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"iI5avH","srOnly":"iI5avH"};